import { Alert, Box, Typography } from "@mui/material";

const ValidationErrorsAlert = ({ messages }) => {
  if (!messages?.length) return null;

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>
        موارد زیر تکمیل یا اصلاح نشده‌اند:
      </Typography>
      <Box component="ul" sx={{ m: 0, pr: 2.5, "& li": { mb: 0.5 } }}>
        {messages.map((msg) => (
          <Box component="li" key={msg}>
            <Typography variant="body2">{msg}</Typography>
          </Box>
        ))}
      </Box>
    </Alert>
  );
};

export default ValidationErrorsAlert;
